import { graphql, navigate } from 'gatsby';
import * as React from 'react';
import styled from 'styled-components';
import ApplicationForm from '../components/ApplicationForm';
import Layout from '../components/Layout';
import GirlDesk from '../images/careers/GirlDesk.svg';

const Section = styled.section`
	padding-top: 0;
	padding-bottom: 1.75em;

	& .position-type {
		font-size: 1.375rem;
		font-weight: bold;
		margin: 1em 0;
	}

	& article.col-12 {
		padding-left: 0;
		padding-right: 0;
	}

	& .static-asides {
		& figure {
			margin-bottom: 2em;

			@media (${(props) => props.theme.mediumUp}) {
				text-align: right;
			}
		}

		& aside {
			margin-bottom: 3em;
			p {
				line-height: 1.41;
			}
		}
	}
`;

interface ApplicationPageProps {
	data: any;
	location: any;
}

class ApplicationPage extends React.Component<ApplicationPageProps> {
	componentDidMount () {
		if (!this.props.location.state || !this.props.location.state.position) {
			navigate('/careers/#open-roles');
		}
	}

	render () {
		const {
			data: {
				site: {
					siteMetadata: { legacyEndpoint },
				},
			},
			location,
		} = this.props;

		return <Layout
			pageTitle='Apply for this position in San Diego, California'
			splashHeaderMinHeight={'none'}
			skipMoney2020={true}
			skipUseCases={true}
		>
			<div className='centeredWrapper'>
				<Section className='row row-flush'>
					{location.state && location.state.position &&
						<article className='form-wrapper col-12 col-md-6'>
							<h1>{location.state.position.title}</h1>
							<p className='position-type'>
								{location.state.position.location}, {location.state.position.type}
							</p>
							<ApplicationForm legacyEndpoint={legacyEndpoint} position={location.state.position.applicationId} />
						</article>
					}
					<article className='static-asides col-12 offset-md-1 col-md-5'>
						<figure>
							<GirlDesk alt='Girl at Desk with Laptop' />
						</figure>
						<aside>
							<h3>Discover</h3>
							<p>MK's culture of growth, innovation, and unity encourages team members to reach new heights when pursuing projects. At MK, there's no limit to what you can do.</p>
						</aside>
						<aside>
							<h3>Teamwork</h3>
							<p>Surround yourself with a team of hard-working innovators and collaborate to unlock your creative potential. Together, let's make lending simple.</p>
						</aside>
						<aside>
							<h3>Equal Opportunity</h3>
							<p>MK Decision is an equal opportunity employer who places great importance on having a safe and diverse workplace. We do not discriminate on the basis of age, race, religion, gender, sexual orientation, marital status, veteran or disability status.</p>
						</aside>
					</article>
				</Section>
			</div>
		</Layout>;
	}
}

export const query = graphql`
	query ApplicationPage {
		site {
			siteMetadata {
				legacyEndpoint
			}
		}
	}
`;

export default ApplicationPage;
